
import { WeatherCondition, WeatherQuote } from '@/types/weather';

export const weatherQuotes: Record<WeatherCondition, WeatherQuote[]> = {
  clear: [
    {
      it: "Il sole splende non per sé stesso, ma per illuminare gli altri.",
      en: "The sun shines not on itself, but to illuminate others.",
      author: "William Shakespeare"
    },
    {
      it: "Tieni il viso rivolto verso il sole e non vedrai le ombre.",
      en: "Keep your face to the sunshine and you cannot see a shadow.",
      author: "Helen Keller"
    },
    {
      it: "Anche il giorno più buio ha fine e il sole sorge nuovamente.",
      en: "Even the darkest day comes to an end, and the sun rises once again.",
      author: "Anonymous"
    }
  ],
  partlyCloudy: [
    {
      it: "La vita non è aspettare che passi la tempesta, ma imparare a ballare sotto la pioggia.",
      en: "Life isn't about waiting for the storm to pass, it's about learning to dance in the rain.",
      author: "Vivian Greene"
    },
    {
      it: "Dietro ogni nuvola c'è sempre il sole che splende.",
      en: "Behind every cloud is the sun still shining.",
      author: "Anonymous"
    },
    {
      it: "Le nuvole possono coprire il sole, ma il sole è sempre lì.",
      en: "Clouds may cover the sun, but the sun is always there.",
      author: "Anonymous"
    }
  ],
  cloudy: [
    {
      it: "Le nuvole sono come i pensieri, vanno e vengono.",
      en: "Clouds are like thoughts, they come and go.",
      author: "Anonymous"
    },
    {
      it: "Non c'è arcobaleno senza un po' di pioggia.",
      en: "No rainbow without a little rain.",
      author: "Anonymous"
    },
    {
      it: "Le nuvole non sono ostacoli, ma parte del paesaggio.",
      en: "Clouds are not obstacles, but part of the landscape.",
      author: "Anonymous"
    }
  ],
  rain: [
    {
      it: "La pioggia è grazia; la pioggia è la cosa, che ci viene data per la vita.",
      en: "Rain is grace; rain is the sky's way of giving life.",
      author: "John Updike"
    },
    {
      it: "Alcuni sentono la pioggia. Altri si bagnano soltanto.",
      en: "Some feel the rain. Others just get wet.",
      author: "Bob Marley"
    },
    {
      it: "Lascia che la pioggia ti baci, lascia che la pioggia canti la sua ninnananna.",
      en: "Let the rain kiss you, let the rain beat upon your head with silver liquid drops.",
      author: "Langston Hughes"
    }
  ],
  heavyRain: [
    {
      it: "Dopo la tempesta c'è sempre il sereno.",
      en: "After the storm comes the calm.",
      author: "Proverb"
    },
    {
      it: "Le tempeste fanno mettere radici più profonde agli alberi.",
      en: "Storms make trees take deeper roots.",
      author: "Dolly Parton"
    },
    {
      it: "Nella tempesta, impara a danzare sotto la pioggia.",
      en: "In the storm, learn to dance in the rain.",
      author: "Anonymous"
    }
  ],
  thunderstorm: [
    {
      it: "I lampi illuminano il cielo come i pensieri illuminano la mente.",
      en: "Lightning lights up the sky as thoughts light up the mind.",
      author: "Anonymous"
    },
    {
      it: "Ci sono tempeste che devono essere vissute in silenzio.",
      en: "There are some storms that must be weathered in silence.",
      author: "Anonymous"
    },
    {
      it: "Il tuono è buono, il tuono è impressionante, ma è il lampo che fa il lavoro.",
      en: "Thunder is good, thunder is impressive; but it is lightning that does the work.",
      author: "Mark Twain"
    }
  ],
  snow: [
    {
      it: "La neve è poesia che cade dalle nuvole.",
      en: "Snow is poetry falling from the clouds.",
      author: "Anonymous"
    },
    {
      it: "Ogni fiocco di neve è un bacio dal cielo.",
      en: "Every snowflake is a kiss from heaven.",
      author: "Anonymous"
    },
    {
      it: "Nell'inverno, sotto la neve, si nasconde un mondo di meraviglie.",
      en: "In winter, under the snow, hides a world of wonder.",
      author: "Anonymous"
    }
  ],
  fog: [
    {
      it: "La nebbia si dissolve, ma la sua bellezza rimane nei nostri cuori.",
      en: "The fog dissipates, but its beauty remains in our hearts.",
      author: "Anonymous"
    },
    {
      it: "La nebbia ci ricorda che il mondo è pieno di misteri.",
      en: "Fog reminds us that the world is full of mysteries.",
      author: "Anonymous"
    },
    {
      it: "Nella nebbia, ci rendiamo conto di quanto sia preziosa la chiarezza.",
      en: "In fog, we realize how precious clarity is.",
      author: "Anonymous"
    }
  ],
  wind: [
    {
      it: "Il vento è l'alito di Dio che passa sulla terra.",
      en: "The wind is the breath of God passing over the earth.",
      author: "Anonymous"
    },
    {
      it: "Ascolta il vento, ha sempre una storia da raccontare.",
      en: "Listen to the wind, it always has a story to tell.",
      author: "Anonymous"
    },
    {
      it: "Come il vento, la libertà non può essere catturata.",
      en: "Like the wind, freedom cannot be captured.",
      author: "Anonymous"
    }
  ],
  alert: [
    {
      it: "Non sfidare la natura, rispettala.",
      en: "Don't challenge nature, respect it.",
      author: "Anonymous"
    },
    {
      it: "La prudenza è la madre della sicurezza.",
      en: "Caution is the mother of safety.",
      author: "Proverb"
    },
    {
      it: "Meglio prevenire che curare.",
      en: "Better safe than sorry.",
      author: "Proverb"
    }
  ]
};

export const getRandomQuoteForCondition = (condition: WeatherCondition): WeatherQuote => {
  const quotes = weatherQuotes[condition];
  const randomIndex = Math.floor(Math.random() * quotes.length);
  return quotes[randomIndex];
};
